import axios from '../../plugins/TradutorInterceptor'

export const actions = {
    listTradutores(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tradutores' + payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    listTradutoresSemPaginacao(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tradutores' + '?page=1&size=-1')
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    createTradutor(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('tradutores', payload)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    updateTradutor(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put(`tradutores/${payload.id}`, payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    showTradutor(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tradutores/' + payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    listarMapeamento(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tradutor/' + payload.id + '/mapeamentos')
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    simularMapeamento(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('tradutor/mapeamentos/' + payload.id + '/simular', payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    salvarMapeamentoTradutor(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('tradutor/mapeamentos/' + payload.id, payload)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                reject(error)
            })
        });
    },
    simularBuilder(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('tradutor/builder/' + payload.tradutor_id + '/simular', payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    traduzirBuilder(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('tradutor/builder/' + payload.tradutor_id + '/traduzir', payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    salvarBuilder(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('tradutor/builder/' + payload.tradutor_id + '/salvar', payload)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                reject(error)
            })
        });
    },
    obterBuilder(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tradutor/builder/' + payload.tradutor_id)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    traduzir(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tradutor/' + payload.concessionaria + '/' + payload.numeroInstalacao + '/traduzir?referencia=' + payload.referencia + '&fonte=' + payload.fonte + '&chave_connect=' + payload.chave_connect)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    traducaoEmMassa(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('traducoes/agendar-traducao', payload)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                reject(error)
            })
        });
    },
    tradutorDashboard(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('tradutor/painel-traducoes/dashboard?&loading=false')
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    listarTraducoes(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('tradutor/painel-traducoes/listar-traducoes?&loading=false', payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    selecionarItem(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('traducoes/selecionar/' + payload.id, payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    obterTotalSelecionados(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('traducoes/total-selecionados/' + payload + '?&loading=false')
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    selecionarEmMassa(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('traducoes/selecionar-todos', payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    setarPendente(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('traducoes/setar-pendente/' + payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        });
    },
    obterRelatorioTraducao(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('traducoes/relatorio-traducao', payload)
                .then(function (res) {
                    resolve(res.data)
                })
                .catch(function (err) {
                    reject(err)
                })
        })
    },
    obterTotalFaturasCapturadas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('traducoes/total-faturas-capturadas/' + payload.inicio + '/' + payload.fim)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    obterFaturasCapturadas(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('traducoes/faturas-capturadas/' + payload.inicio + '/' + payload.fim + payload.params  )
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    },
    acionarConnect(context, payload) {
        return new Promise((resolve, reject) => {
            axios.put('traducoes/acionar-connect/' + payload.data, payload)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                reject(error)
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/tradutor.js